import {
  Sun, BatteryCharging, Cable, Leaf, Landmark, Server,
} from "lucide-react";

export const WHATSAPP_NUMBER = "918451099371";
export const WHATSAPP_LINK = "https://wa.me/918451099371";
export const EMAIL = "info@growthifye.com";
export const PHONE = "+91 84510 99371";
export const LINKEDIN_URL = "https://www.linkedin.com/company/growthifye";

export const OTHER_SERVICES = [
  "IT Consulting Services",
  "Digital Transformation for Utilities",
  "Green Energy Purchase (PPA)",
  "Circularity Innovation",
  "Utilities Automation Solutions",
  "NGO Advisory & Funding",
];

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "BESS Sizing", href: "#bess" },
  { label: "Approach", href: "#approach" },
  { label: "Impact", href: "#impact" },
  { label: "FAQ", href: "#faq" },
];

export const MARQUEE_ITEMS = [
  { label: "Renewable Energy", to: "/coreservices/re-storage-advisory" },
  { label: "Energy Storage", to: "/coreservices/re-storage-advisory/bess-re-detailed-design" },
  { label: "Small Hydro", to: "/coreservices/re-storage-advisory/feasibility-bankability" },
  { label: "RTC / FDRE", to: "/coreservices/re-storage-advisory/rtc-fdre-modelling" },
  { label: "Green Hydrogen", to: "/coreservices/re-storage-advisory/green-hydrogen" },
  { label: "Pumped Hydro", to: "/coreservices/re-storage-advisory/pumped-hydro" },
  { label: "EPC", to: "/coreservices/epc" },
  { label: "BESS", to: "/coreservices/epc/bess-system-integration" },
  { label: "Transmission Networks", to: "/coreservices/transmission-engineering" },
  { label: "Green Financing", to: "/coreservices/green-financing" },
  { label: "Debt Syndication", to: "/coreservices/green-financing/debt-syndication" },
  { label: "Project Financing", to: "/coreservices/green-financing/lender-grade-financial-modelling" },
  { label: "Data Centers & Energy Mgmt", to: "/coreservices/data-centers-energy-management" },
  { label: "Green PPAs", to: "/coreservices/green-energy-ppa" },
  { label: "Asset Monetisation & PPP", to: "/coreservices/asset-monetisation-ppp" },
  { label: "Net Zero & Decarbonisation", to: "/coreservices/net-zero-decarbonisation" },
  { label: "Utility Digitalisation", to: "/coreservices/utilities-automation" },
  { label: "Circularity", to: "/coreservices/circularity-innovation" },
  { label: "IT Consulting", to: "/coreservices/it-consulting" },
  { label: "NGO Advisory & Funding", to: "/coreservices/ngo-advisory-funding" },
];

export const SERVICES = [
  {
    id: "advisory",
    num: "01",
    slug: "re-storage-advisory",
    title: "RE & Energy Storage Advisory & Engineering",
    desc: "End-to-end advisory, BESS & RE detailed design and engineering for utility-scale solar, wind, small hydro, hybrid and battery storage — including advisory and modelling for RTC and FDRE, feasibility, grid integration, technical & financial due diligence, PMC and independent engineer services.",
    tags: [
      { label: "BESS & RE Design", to: "/coreservices/restorageadvisory/bessredetaileddesign" },
      { label: "RTC / FDRE Advisory", to: "/coreservices/restorageadvisory/rtcfdremodelling" },
      { label: "Technical & Financial DD", to: "/coreservices/restorageadvisory/technicalfinancialdd" },
      { label: "PMC", to: "/coreservices/restorageadvisory/pmc" },
    ],
    icon: Sun,
    image: "/services/advisory.jpg",
    span: "lg:col-span-7",
  },
  {
    id: "epc",
    num: "02",
    slug: "epc",
    title: "EPC — Engineering, Procurement & Construction",
    desc: "Turnkey delivery of clean-energy assets with rigorous quality, cost and schedule control across the full construction lifecycle.",
    tags: [
      { label: "Turnkey", to: "/coreservices/epc/solarandhybridplantepc" },
      { label: "QA/QC", to: "/coreservices/epc/qaqcandhseenforcement" },
      { label: "Commissioning", to: "/coreservices/epc/testingcommissioningandhandover" },
    ],
    icon: BatteryCharging,
    image: "/services/epc.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "transmission",
    num: "03",
    slug: "transmission-engineering",
    title: "Transmission Network Engineering",
    desc: "High-voltage substation and transmission line engineering, grid connection studies and evacuation infrastructure that carry power reliably from source to load.",
    tags: [
      { label: "HV Substations", to: "/coreservices/transmissionengineering/hvehvsubstationdesign" },
      { label: "Grid Studies", to: "/coreservices/transmissionengineering/powersystemstudies" },
      { label: "Evacuation", to: "/coreservices/transmissionengineering/transmissionlineengineering" },
    ],
    icon: Cable,
    image: "/services/transmission.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "green-financing",
    num: "04",
    slug: "green-financing",
    title: "Green Financing & Debt Syndication",
    desc: "Sustainability-linked loans, blended finance, non-recourse project debt and equity fund raising — from framework design and financial modelling to term sheets and financial close.",
    tags: [
      { label: "Green Frameworks", to: "/coreservices/greenfinancing/greenfinancingframeworks" },
      { label: "SLL", to: "/coreservices/greenfinancing/sustainabilitylinkedloans" },
      { label: "Blended Finance", to: "/coreservices/greenfinancing/blendedandconcessionalfinance" },
      { label: "Project Finance", to: "/coreservices/greenfinancing/lendergradefinancialmodelling" },
      { label: "Syndication", to: "/coreservices/greenfinancing/debtsyndication" },
      { label: "Fund Raising", to: "/coreservices/greenfinancing/equityandmezzaninefundraising" },
    ],
    icon: Leaf,
    image: "/services/green-financing.jpg",
    span: "lg:col-span-7",
  },
  {
    id: "data-centers",
    num: "05",
    slug: "data-centers-energy-management",
    title: "Data Centers & Energy Management",
    desc: "Power infrastructure, 24/7 clean energy supply and energy management services for data centers and large digital loads — from RTC green power contracting to on-site generation, BESS and EMS-driven optimisation.",
    tags: [
      { label: "24/7 Clean Power", to: "/coreservices/datacentersenergymanagement/247cleanpowercontracting" },
      { label: "DC Power Infra", to: "/coreservices/datacentersenergymanagement/loadandreliabilityengineering" },
      { label: "EMS", to: "/coreservices/datacentersenergymanagement/energymanagementsystems" },
    ],
    icon: Server,
    image: "/services/datacenter.jpg",
    span: "lg:col-span-7",
  },
];

export const STATS = [
  { value: 2, prefix: "$", suffix: "B", label: "Capital raised & syndicated" },
  { value: 500, suffix: " MWh", label: "BESS capacity executed" },
  { value: 50, prefix: "Over ", suffix: "+", label: "Consulting projects executed" },
  { value: 200, suffix: "+", label: "Man Years Expertise" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Engineering-led advisory",
    body: "Every recommendation is grounded in first-principles engineering. We don't just model spreadsheets — we design the asset, size the storage and stress-test the grid connection before a rupee is committed.",
  },
  {
    num: "02",
    title: "From electrons to evacuation",
    body: "We cover the full value chain: generation and storage, EPC delivery, and the transmission networks that move power to where it's needed. One accountable partner, end to end.",
  },
  {
    num: "03",
    title: "Capital that closes",
    body: "Bankable projects need bankable structures. Our green financing and debt syndication desk turns robust engineering into financial close with the right lenders and the right terms.",
  },
];

export const APPROACH = [
  { step: "01", title: "Assess", points: ["Resource & site assessment", "Grid & regulatory scan", "Opportunity sizing"] },
  { step: "02", title: "Engineer", points: ["Detailed engineering", "BESS & storage sizing", "Evacuation design"] },
  { step: "03", title: "Finance", points: ["Financial modelling", "Green & debt structuring", "Lender syndication"] },
  { step: "04", title: "Deliver", points: ["EPC execution", "Commissioning", "Performance monitoring"] },
];

export const FAQS = [
  {
    q: "What sectors does Growthifye cover?",
    a: "We work across the clean-energy value chain — utility-scale solar and wind, battery energy storage (BESS), power transmission networks, and the green financing structures that fund them.",
  },
  {
    q: "Do you handle both engineering and financing?",
    a: "Yes. Our differentiator is combining engineering-led advisory and EPC with an in-house green financing and debt syndication desk, so technical and financial workstreams stay aligned all the way to financial close.",
  },
  {
    q: "Can you support transmission and grid connection?",
    a: "Absolutely. We engineer HV substations and transmission lines, run grid connection and evacuation studies, and manage the interface with utilities and grid operators.",
  },
  {
    q: "What does green financing include?",
    a: "Sustainability-linked loans, green debt, blended finance and non-recourse project finance — structured, syndicated and negotiated to secure competitive, long-tenor capital.",
  },
  {
    q: "How do we start working with you?",
    a: "Share your project or mandate through the contact form or WhatsApp. We'll set up a discovery call and outline a tailored engagement across advisory, engineering, EPC or financing.",
  },
];
